import { jsx } from "react/jsx-runtime";
import { Alert } from "@mantine/core";
const FallbackComponent = () => /* @__PURE__ */ jsx(Alert, { title: "Der skete en fejl i komponenten", variant: "filled", children: "Denne boks bliver kun vist i test og lokalt miljø. Læs mere om fejlen i konsollen" });
export {
  FallbackComponent as default
};
